import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrossWordsGameSelectorComponent } from './cross-words-game-selector/cross-words-game-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CrossWordsGameCoreService } from './cross-words-game-core.service';

@NgModule({
  declarations: [CrossWordsGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [CrossWordsGameCoreService],
  exports: [CrossWordsGameSelectorComponent],
})
export class CrossWordsGameCoreModule {}
